import React, { Component } from "react";
import { Form, Button } from "semantic-ui-react";
import Flatpickr from "react-flatpickr";
import CheckboxFilter from "../forms/elements/CheckboxFilter";

const dateRangePicker = {
  mode: "range"
};

class ReportFilters extends Component {
  render() {
    const { currentState, change, fetch, download } = this.props;
    return (
      <Form loading={currentState.isLoading} onSubmit={fetch}>
        <Form.Group inline>
          <label>Choose a report</label>
          <Form.Select
            name="apiEndpoint"
            placeholder="Report"
            search
            options={currentState.reportOptions}
            value={currentState.reportId}
            onChange={change}
            autoComplete="off"
          />
          <label>and filter by event</label>
          <CheckboxFilter
            name="eventIds"
            options={currentState.eventOptions}
            value={currentState.eventIds}
            onChange={change}
          />
          <Form.Field>
            <label>or by date range</label>
            <Flatpickr
              name="datesRange"
              value={currentState.datesRange || ""}
              placeholder="Start to End"
              options={dateRangePicker}
              onChange={(_, str, b) =>
                this.props.change(b.element, { name: "datesRange", value: str })
              }
            />
          </Form.Field>
          <Button primary onClick={fetch}>
            Create Report
          </Button>
          {currentState.data.length > 0 ? (
            <Button type="button" secondary onClick={download}>
              Export Report
            </Button>
          ) : (
            ""
          )}
        </Form.Group>
      </Form>
    );
  }
}

export default ReportFilters;
